import styled from 'styled-components';

export const StepColor = styled.div`
    color: ${props => !props.active && 'var(--f-gray-400)'};
`;
